import Carousel from './carousel';

class ProductSlider extends Carousel {
  constructor(selector: HTMLElement | string) {
    const TIME = 5000;
    const SPEED = 800;

    const el: HTMLElement | null = selector instanceof HTMLElement ? selector : document.querySelector(selector);
    const slideCount = selector instanceof HTMLElement ? selector.querySelectorAll('.swiper-slide').length : null;

    super(selector, {
      effect: 'slide',
      grabCursor: true,
      speed: SPEED,
      slidesPerView: el?.classList.contains('lightbox-slider') ? 3 : 1.25,
      spaceBetween: 10,
      loop: !slideCount || (window.innerWidth < 768 && slideCount && slideCount > 1) || (slideCount && slideCount > 3) ? true : false,
      autoplay: false,
      navigation: {
        nextEl: selector instanceof HTMLElement ? selector.closest('.o-product-slider')?.querySelector('.swiper-button-next') : '.swiper-button-next',
        prevEl: selector instanceof HTMLElement ? selector.closest('.o-product-slider')?.querySelector('.swiper-button-prev') : '.swiper-button-prev',
      },
      observer: true,
      observeParents: true,
      breakpoints: {
        1260: {
          slidesPerView: 3,
          spaceBetween: 75,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 75,
        },
        768: {
          slidesPerView: el?.classList.contains('lightbox-slider') ? 3 : 1.33,
          spaceBetween: 55,
        },
        450: {
          spaceBetween: 20,
        }
      },
      on: {
        afterInit: (swiper: any) => {
          if (swiper.slides.length - 2 <= 1 && window.innerWidth > 768) {
            swiper.autoplay.stop();
            swiper.unsetGrabCursor();
            swiper.params.grabCursor = false;
            swiper.params.loop = false;
            el?.classList.add('swiper-no-swiping');
          }
        },
      }
    });
  }

  init() {
    super.init();
  }
}

export default ProductSlider;
